import(/* webpackMode: "eager" */ "/Users/tamam/projects/particlelife/src/app/particle-embed/page.tsx");
